<div class="k-form-field">
  <div [innerHTML]="question.question"></div>
  <ol type="a" *ngIf="showSubInfo">
    <li>Answer Yes if their employer does <b>not</b> offer PEBB or SEBB coverage, or a TRICARE plan.</li>
    <li>Answer No if their employer offers PEBB or SEBB coverage, or a TRICARE plan.  </li>
  </ol>
  <div fxFlexLayout="row" fxLayoutAlign="space-around center">
    <span *ngFor="let response of responses">
      <radio
        [name]="'spouseQuestionResponse_' + question?.questionId + '_' + response.responseId"
        radioAsCheckbox
        [disabled]="disabled"
        [value]="response.responseId"
        [label]="response.responseName"
        [(ngModel)]="responseId"
        (change)="updateAnswer()"
      ></radio>
    </span>
  </div>
</div>